import { SpecifierName } from '@gin-betting/constants';

import { GetSpecifierHandler } from '../types';

export const getHcpSpecifier: GetSpecifierHandler = specifiers =>
    specifiers.find(s => s.name === SpecifierName.hcp);
export const getTotalSpecifier: GetSpecifierHandler = specifiers =>
    specifiers.find(s => s.name === SpecifierName.total);
